module.exports = __webpack_public_path__ + "media/video_poster/desktop-1f004c00.webp";